module.exports = __webpack_public_path__ + "static/media/lock.e4409610.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/lock.svg
// module id = 576
// module chunks = 0